import React from 'react';
import { camelCase } from 'lodash';

import { FormProps } from './types';

function Select({
  question, name, onChange, value,
}: FormProps, ref) {
  if (question.type !== 'select') return null;

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div className="dynamic-form-input">
        <select ref={ref} name={name} onChange={onChange} value={value}>
          <option value="" disabled>{`Select ${question.label}`}</option>
          {
            question.values.map((v) => (
              <option key={camelCase(`${name}-${v}`)} value={v}>{v}</option>
            ))
          }
        </select>
      </div>
    </>
  );
}

export default React.forwardRef(Select);
